import { render, staticRenderFns } from "./AnswerSelected.vue?vue&type=template&id=5cdb7b38"
import script from "./AnswerSelected.vue?vue&type=script&lang=js"
export * from "./AnswerSelected.vue?vue&type=script&lang=js"
import style0 from "./AnswerSelected.vue?vue&type=style&index=0&id=5cdb7b38&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports